module.exports = __webpack_public_path__ + "static/media/pathMap.a76cd8dc.png";